export const defaultBackgroundTransition = 'background-color 0.3s ease';
